import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectServe from "@/components/SelectServe.vue";
import TreeSelect from "@/components/TreeSelect.vue";
import RightsliDialog from "@/components/management/rightsli/RightsliDialog";
import { getDutyList, getDutyInfo, handleDutyDelete } from "@/api/managementCenter/chargeManage";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "Rightsli",
  components: {
    SelectServe: SelectServe,
    TreeSelect: TreeSelect,
    RightsliDialog: RightsliDialog
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        serveIds: [],
        respDeptId: ""
      },
      total: 0,
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      departmentData: [],
      serveList: []
    };
  },
  mounted: function mounted() {
    this.getListFn();
    this.getDeptTreeData();
  },
  methods: {
    mapToArr: function mapToArr(strs) {
      var str = strs || "";
      return str.split(",");
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.paramSearch.respDeptId = data.id;
    },
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.departmentData = data.data;
        }
      }).catch(function (err) {});
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      this.loading = true;
      this.paramSearch.serveIds = this.serveList.map(function (item) {
        return item.serve_id;
      }).join(",");
      getDutyList(this.paramSearch).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.list = data.data.records || [];
          _this2.total = data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 添加
    addFn: function addFn() {
      this.$refs.SpecialDialog.dialogShow("add");
    },
    // 删除
    deleteFn: function deleteFn(id, name) {
      var _this3 = this;

      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.deleteHttp(id);
      }).catch(function () {
        _this3.$message.info("已取消删除");
      });
    },
    deleteHttp: function deleteHttp(id) {
      var _this4 = this;

      this.loading = true; // 删除接口

      handleDutyDelete(id).then(function (_ref3) {
        var data = _ref3.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$message.success("删除成功!");

          _this4.getListFn();
        } else {
          _this4.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function () {
        _this4.loading = false;

        _this4.$message.error("删除异常!");
      });
    },
    // 详情
    editFn: function editFn(id) {
      var _this5 = this;

      this.loading = true;
      getDutyInfo(id).then(function (_ref4) {
        var data = _ref4.data;
        _this5.loading = false;

        if (data.code == 0) {
          _this5.$refs.SpecialDialog.dialogShow("edit", data.data);
        } else {
          _this5.$message.warning(data.msg || "获取权责信息失败！");
        }
      }).catch(function (err) {
        _this5.loading = false;
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread({}, this.paramSearch), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    },
    sureSelect: function sureSelect(data) {
      this.serveList = data;
    },
    serveSelect: function serveSelect() {
      this.$refs.selectServeRef.openDialog(this.serveList);
    },
    handleClose: function handleClose(tag) {
      this.serveList = this.serveList.filter(function (item) {
        return item.serve_id != tag.serve_id;
      });
    }
  },
  watch: {},
  filters: {}
};